<template>
  <div class="columns session-responsive">
    <div class="column is-one-third view-filter">
      <p class="hint"><i @click="long = !long" class="fad fa-arrows-h pointer" title="Expand types"></i>
        <span class="white-space: nowrap;" v-if="!long">{{ hint }}</span>
      </p>
      <div class="tags session-types">

          <span class="tag is-dark"
                v-for="(sessionType, index) in sessionTypes" :title="sessionType.name"
                @click="addToTypes(sessionType)" @mouseover="hint = sessionType.name" @mouseleave="hint = ''">
            <span v-if="long">{{ sessionType.name }}</span> <span v-if="! long">{{ sessionType.short_name || sessionType.name }}</span>
          </span>
      </div>
      <p><small>Local {{ event.timezone }}</small>:</p>
      <div class="tags session-types">

          <span class="tag is-info"
                v-for="(localDay, index) in localDays" :title="localDay.name"
                @click="addToDays(localDay)">
            {{ localDay.format }}
          </span>
      </div>
    </div>
    <div class="column is-two-thirds view-list">
      <h1>Quick Lookup</h1>
      <p>By default, quick lookup starts from sessions that have recently started.</p>
      <p>You can also <a href="/schedule/index">view the schedule</a>.</p>

      <input type="text" @keyup="searchSessions" placeholder="Search by title, id, content, or presenter" v-model="search"
             class="input">

      <hr>
      <div class="tags">
          <span v-if="search" class="tag is-info">
            {{ search }}
            <button v-on:click="resetSearch" class="delete is-small"></button>
          </span>
        <span v-for="(selectedType, index) in selectedTypes" class="tag is-success">
            {{ sessionTypeNameById(selectedType) }}
            <button v-on:click="removeFromTypes(selectedType)" class="delete is-small"></button>
          </span>
        <span v-for="(selectedDay, index) in selectedDays" class="tag is-default">
            {{ selectedDay }}
            <button v-on:click="removeFromDays(selectedDay)" class="delete is-small"></button>
          </span>
        <span v-for="(selectedPresenter, index) in selectedPresenters" class="tag is-warning">
            {{ selectedPresenter.name }}
            <button v-on:click="removeFromPresenters(selectedPresenter)" class="delete is-small"></button>
          </span>
      </div>


      <ul style="margin-top: 20px;">
        <li class="session-overview" v-for="(session, index) in sessions" :key="session.id">
          <div class="columns">
            <div class="column is-1 is-hidden-mobile">
              <div class="session-presenter" v-for="p in session.participants">
                <figure class="image" v-html="avatarImage(p)"></figure>
              </div>
            </div>
            <div class="column is-11">
              <h1 class="session-title"><a :href="sessionLink(session.id)">{{ session.title }}</a>
                <small>#{{ session.id }}</small>
                <i class='fa-heart'
                   :class="fasClasses(session)"
                   @click="toggle(session)"></i></h1>
              <p class="session-time">{{ getTime(session.starts_at, session.ends_at) }} <strong> | </strong>
                 {{getLocationName(session)}}</p>
              <p class="session-description">{{ session.description }}</p>
              <p class="session-type">{{ sessionTypeName(session) }}</p>
              <div class="session-presenters">
                    <span class="session-presenter" v-for="p in session.participants">
                      <span v-on:click="addToPresenters(p)" :class="pClass(p)">
                        {{ participantName(p) }}</span> <span class="delimiter"> / </span>
                    </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

// https://www.tutspack.com/blog/laravel-instant-search-example-using-vue-js-and-debounce
// https://stackoverflow.com/questions/49025064/vuejs-using-computed-property-for-array-elements


import axios from "axios";
import _ from "lodash";
import qs from "qs";

import VueSanitize from "vue-sanitize";

Vue.use(VueSanitize, {
  allowedTags: ['strong', 'em', 'p']
});

export default {
  name: "SessionResponsive",
  props: {
    event: {
      type: Object,
      default() {
        return {};
      },
      required: true
    },
    favoriteSessions: {
      type: Array,
      default() {
        return [];
      },
      required: true
    },
  },
  created() {
    this.getTypes();
    this.getLocalDays();
    this.getInitial();

  },

  data() {
    return {
      sessions: [],
      sessionTypes: [],
      localDays: [],
      search: '',
      selectedTypes: [],
      selectedDays: [],
      sessionTypesArray: [],
      selectedPresenters: [],
      long: false,
      hint: '',
      timezone: this.event.timezone ?? 'UTC',
      favorites: this.favoriteSessions,
    }
  },
  methods: {
    fasClasses(session) {

      const loved = this.favorites.includes(session.id);

      return [
        'fa-heart',
        loved ? 'fas' : 'far'
      ];
    },
    toggle(session) {
      const loved = this.favorites.includes(session.id);
      loved ? this.destroy(session) : this.create(session);
    },
    create(session) {
      axios.post('/session/' + session.id + '/favorite').then(response => {
        this.favorites.push(session.id);
      })

    },

    destroy(session) {
      axios.delete('/session/' + session.id + '/favorite').then(response => {
        const index = this.favorites.indexOf(session.id);
        if (index !== -1) {
          this.favorites.splice(index, 1);
        }
      })

    },
    sanitize(text){
      return this.$sanitize(text);
    },

    pClass(p) {
      //console.log(p.is_main);
      //console.log(p.member);
      let c = p.is_main ? 'is-main' : 'not-main';
      //console.log(c);
      if (p.member) {
        c = c + ' is-member';
      }
      //console.log(c);
      return c + ' p';
    },
    participantLink(p) {
      return '/person/' + p.id;
    },

    participantName(p) {
      if (p.member) {
        return p.member.name;
      }
      //return 'unknown';
      return p.temp_name;
    },

    getLocationName: function(session){
      if (session.location && session.location.name) {
        return session.location.name;
      }
      return 'Location not set'
    },

    getStartTime: function (isoTime) {

      if (!isoTime) {
        return '';
      }

      let jst = moment.tz(isoTime, this.timezone);
      //let time = Date.parseLocale(isoTime);
      //console.log(jst);
      //return jst.format('H:mm');
      return jst.format('ddd, MMMM Do, H:mm');
    },
    getEndTime: function (isoTime) {
      if (!isoTime) {
        return '';
      }
      let jst = moment.tz(isoTime, this.timezone);
      //let time = Date.parseLocale(isoTime);
      //console.log(jst);
      return jst.format('H:mm [' + this.timezone + ']');
    },

    getTime: function (isoTimeStart, isoTimeEnd) {

      if (!isoTimeStart && !isoTimeEnd) {
        return 'Not yet scheduled';
      }
      let dayStart = '';
      let timeStart = '';
      let jstStart = '';
      if (isoTimeStart) {
        jstStart = moment.tz(isoTimeStart, this.timezone);
        dayStart = jstStart.format('MMMM Do');
        timeStart = jstStart.format('ddd, MMM Do, HH:mm');
      }
      let dayEnd = '';
      let timeEnd = '';
      let jstEnd = '';
      if (isoTimeEnd) {
        jstEnd = moment.tz(isoTimeEnd, this.timezone);
        dayEnd = jstEnd.format('MMMM Do');
        timeEnd = jstEnd.format('ddd, MMM Do, HH:mm ' + this.shortTimeZone);
      }

      if (dayStart && (dayStart === dayEnd)) {
        return jstStart.format('ddd, MMM Do, HH:mm') + ' ~ ' + jstEnd.format('HH:mm ' + this.shortTimeZone);
      }
      return timeStart + ' ~ ' + timeEnd;
    },

    addHint() {
      this.hint = 'hint';
    },
    resetSearch() {
      this.search = '';
      this.searchSessions();
    },
    addToPresenters(p) {

      if (!p.member) {
        return;
      }

      const newPresenter = {
        id: p.member.id,
        name: (p.member ? p.member.name : p.temp_name)
      };

      //console.log(newPresenter);

      if (!this.selectedPresenters.some(el => el.id === p.member.id)) {
        this.selectedPresenters.push(newPresenter);
        this.selectedTypes = [];
        this.selectedDays = [];
        this.searchSessions();
      }


    },
    removeFromPresenters(p) {

      const newPresenters = [];
      for (let i = 0; i < this.selectedPresenters.length; i++) {
        //console.log(this.selectedDays[i]);
        if (this.selectedPresenters[i].id !== p.id) {
          newPresenters.push(this.selectedPresenters[i]);
        }
      }
      this.selectedPresenters = newPresenters;
      this.searchSessions();
    },
    addToTypes(type) {

      if (this.selectedTypes.includes(type.id) === false) {
        this.selectedTypes.push(type.id);
        this.searchSessions();
      }


      /*if (!this.selectedTypes.some(el => el.id === type.id)) {
        this.selectedTypes.push(type.id);
      }*/

    },

    removeFromTypes(id) {

      //console.log(this.selectedTypes[i]);

      //this.selectedTypes.push(type);
      const newTypes = [];
      for (let i = 0; i < this.selectedTypes.length; i++) {
        //console.log(this.selectedTypes[i]);
        if (this.selectedTypes[i] !== id) {
          newTypes.push(this.selectedTypes[i]);
        }
      }
      this.selectedTypes = newTypes;
      this.searchSessions();
    },

    addToDays(day) {

      if (this.selectedDays.includes(day.date) === false) {
        this.selectedDays.push(day.date);
        this.selectedDays.sort();
        this.searchSessions();
      }
    },
    removeFromDays(date) {

      //console.log(this.selectedDays[i]);

      //this.selectedDays.push(type);
      const newDays = [];
      for (let i = 0; i < this.selectedDays.length; i++) {
        //console.log(this.selectedDays[i]);
        if (this.selectedDays[i] !== date) {
          newDays.push(this.selectedDays[i]);
        }
      }
      this.selectedDays = newDays;
      this.searchSessions();
    },

    avatarImage(p) {

      if (p.member) {
        return '<img class="is-rounded" src="/' + p.member.avatar_path + '" alt="' + p.member.name + '">';
      }
      return '<img class="is-rounded" src="/img/user-astronaut.png" alt="' + p.temp_name + '">';

    },

    sessionTypeName(session) {
      if (session.type != null) {
        return session.type.name;
      }
      return '-';
    },
    sessionTypeNameById(id) {

      const found = this.sessionTypes.find(el => el.id === id);
      return found.name;

    },
    selectedPresenterNameById(p) {

      //const found = this.sessionTypes.find(el => el.id === id);
      //return found.name;

    },
    sessionTypeShortNameById(id) {

      const found = this.sessionTypes.find(el => el.id === id);
      return found.short_name;

    },
    searchSessions: _.debounce(function () {

      let members = this.selectedPresenters.map(p => p.id);

      axios.get('/search/general', {
        params: {
          firstDay: -1,
          search: this.search,
          selectedTypes: this.selectedTypes,
          selectedDays: this.selectedDays,
          selectedMembers: members,
          limit: 50,
        },
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            this.sessions = response.data;
          })
          .catch(error => {


          });
    }),
    sessionLocationName(session) {
      if (session.location != null) {
        return session.location.name;
      }
      return '-';
    },
    sessionLink(id) {
      return '/session/' + id;
    },
    getTypes() {
      axios.get(this.listUrl)
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            this.sessionTypes = response.data;
          })
          .catch(error => {

          });
    },
    getLocalDays() {
      axios.get(this.localListURL)
          .then(response => {
            this.localDays = response.data;
          })
          .catch(error => {


          });
    },
    getInitial() {

      // https://stackoverflow.com/questions/49944387/how-to-correctly-use-axios-params-with-arrays

      axios.get('/search/general', {
        params: {
          firstDay: -1,
          search: this.search,
          selectedTypes: this.selectedTypes
        },
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            this.sessions = response.data;
          })
          .catch(error => {

          });
    },
  },
  computed: {
    listUrl() {
      return '/api/event/' + this.event.id + '/list/session_types';
    },
    localListURL() {
      return '/api/event/' + this.event.id + '/list/session_local_days';
    },
    shortTimeZone() {
      if (this.timezone === 'Asia/Tokyo') {
        return '[JST]';
      }
      return '[' + this.timezone + ']';
    }

  }
}
</script>

<style scoped>

.session-overview {
  border-radius: 0.9rem;
  border-width: 1px;
  border-color: rgba(0, 0, 0, .03);
  border-style: solid;
  background-color: rgba(0, 0, 0, .01);
  margin-bottom: 1rem;
  padding: 20px;


}


.session-overview p{
  margin: 0;
}

.session-overview p.session-description{
  margin: 1em 0;
}

.session-overview p.session-time{
  margin: 0;
  font-size: 0.75rem;
}

.session-overview .session-title{
  color: #ccc ;
  font-size: 1.23rem;
  margin: 0;
}

.session-overview p.session-type{
  color: #999 ;
}

.session-responsive .view-filter {

}

.session-responsive .view-list {

}

.session-types span {
  border-radius: 30px;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.hint {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.delimiter {
  color: #ccc;
}

.session-presenter:last-child .delimiter {
  display: none;
}

figure.image {
  margin-bottom: 5px;
}

.p {

}

.p.is-member{
  color: #06bcef;
  cursor: pointer;
}

.p.is-main {
  font-weight: bold;
}

.fa-heart {
  cursor: pointer;
  color: #e74444;
  font-size: 0.7em;
}

.red {
  color: red;
}

.pointer {
  cursor: pointer;
}


</style>